import React from "react";
import { Col, Row } from "react-bootstrap";

import {
  TEACH_PLAY_STORE_URL,
  TEACH_APP_STORE_URL,
  LEARN_PLAY_STORE_URL,
  LEARN_APP_STORE_URL,
} from "../constants/common";

import "./app-stores.css";

function AppStores(props) {
  let playStoreUrl = LEARN_PLAY_STORE_URL;
  let appStoreUrl = LEARN_APP_STORE_URL;

  if (props.app === "teach") {
    playStoreUrl = TEACH_PLAY_STORE_URL;
    appStoreUrl = TEACH_APP_STORE_URL;
  }

  return (
    <Row className="align-items-center flex-nowrap app-store">
      <Col
        as="a"
        href={playStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="google-play-store"
      >
        <img
          alt="Playstore logo"
          src="/play-store.jpeg"
          className="img-responsive w-100 app-store-img"
        />
      </Col>
      <Col
        as="a"
        href={appStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="apple-play-store"
      >
        <img
          alt="Appstore logo"
          src="/apple-image.svg"
          className="img-responsive w-100 app-store-img"
        />
      </Col>
    </Row>
  );
}

export default AppStores;
